// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftDiv {
    border-right: #D2D2D2 1px solid;
    padding-right: 10px;
    margin-right: 10px;
    width: 350px;
}

.rightDiv {
    width: 500px;
}

.textBlockAll {
    margin-right: 5px;
}

    .textBlockAll:hover {
        color: #3E78B3;
        cursor: pointer;
    }

.textBlockClear {
    margin-left: 5px;
}

    .textBlockClear:hover {
        color: #CC4A31;
        cursor: pointer;
    }

.blueColor {
    color: #3E78B3;
}

.isBold {
    font-weight: bold;
}

.smallborderFirstChar {
    border-radius: 16px;
    width: 16px;
    height: 16px;
    bottom: 0px;
    position: absolute;
    display: flex;
}

.borderFirstChar {
    border: 1px solid transparent;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    margin: 2px;
    align-self: center;
    text-align: center;
    margin-right: 10px;
    flex-shrink: 0;
}

.textBlockFirstChar {
    flex: 1 1 auto;
    color: white;
    align-self: center;
    text-align: center;
}

.standardText {
    font-family: Roboto, "Helvetica Neue", sans-serif;
    line-height: 1.4;
    align-self: center;
    text-overflow: ellipsis;
}

.descText {
    vertical-align: initial;
    padding-right: 5px;
}

.descMessage {
    overflow: auto;
    word-wrap: break-word;
    height: calc(100% - 5px);
}

.headerText {
    margin-left: 5px;
    white-space: nowrap;
}

.listbox-item {
    cursor: pointer;
    width: 100%;
    height: 50px;
    text-align: left;
    border-radius: 0;
}

    .listbox-item:hover {
        background-color: grey;
    }

.listbox-item-selected {
    background-color: var(--primary-color);
}

    .listbox-item-selected:hover {
        background-color: var(--primary-color);
    }

.online_indicator {
    margin-left: 20px;
    width: 20px;
    height: 20px;
    border: 1px solid transparent;
    border-radius: 10px;
    background-color: green;

    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
    transform: scale(1);
    animation: pulse 2s infinite;
}
.online {
    background-color: green;
}
.offline {
    background-color: red;
}
@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
}

.messageGrid {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-template-rows: auto 1fr;
}

.messageGrid > * {
    margin-top: 5px;
    align-self: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/messagecenter/messagecenter.control.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;IAEI;QACI,cAAc;QACd,eAAe;IACnB;;AAEJ;IACI,gBAAgB;AACpB;;IAEI;QACI,cAAc;QACd,eAAe;IACnB;;AAEJ;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,sCAAsC;AAC1C;;IAEI;QACI,sCAAsC;IAC1C;;AAEJ;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;;IAEvB,oCAAoC;IACpC,mBAAmB;IACnB,4BAA4B;AAChC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;AACA;IACI;QACI,sBAAsB;QACtB,sCAAsC;IAC1C;;IAEA;QACI,mBAAmB;QACnB,uCAAuC;IAC3C;;IAEA;QACI,sBAAsB;QACtB,oCAAoC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B","sourcesContent":[".leftDiv {\n    border-right: #D2D2D2 1px solid;\n    padding-right: 10px;\n    margin-right: 10px;\n    width: 350px;\n}\n\n.rightDiv {\n    width: 500px;\n}\n\n.textBlockAll {\n    margin-right: 5px;\n}\n\n    .textBlockAll:hover {\n        color: #3E78B3;\n        cursor: pointer;\n    }\n\n.textBlockClear {\n    margin-left: 5px;\n}\n\n    .textBlockClear:hover {\n        color: #CC4A31;\n        cursor: pointer;\n    }\n\n.blueColor {\n    color: #3E78B3;\n}\n\n.isBold {\n    font-weight: bold;\n}\n\n.smallborderFirstChar {\n    border-radius: 16px;\n    width: 16px;\n    height: 16px;\n    bottom: 0px;\n    position: absolute;\n    display: flex;\n}\n\n.borderFirstChar {\n    border: 1px solid transparent;\n    border-radius: 20px;\n    width: 40px;\n    height: 40px;\n    margin: 2px;\n    align-self: center;\n    text-align: center;\n    margin-right: 10px;\n    flex-shrink: 0;\n}\n\n.textBlockFirstChar {\n    flex: 1 1 auto;\n    color: white;\n    align-self: center;\n    text-align: center;\n}\n\n.standardText {\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    line-height: 1.4;\n    align-self: center;\n    text-overflow: ellipsis;\n}\n\n.descText {\n    vertical-align: initial;\n    padding-right: 5px;\n}\n\n.descMessage {\n    overflow: auto;\n    word-wrap: break-word;\n    height: calc(100% - 5px);\n}\n\n.headerText {\n    margin-left: 5px;\n    white-space: nowrap;\n}\n\n.listbox-item {\n    cursor: pointer;\n    width: 100%;\n    height: 50px;\n    text-align: left;\n    border-radius: 0;\n}\n\n    .listbox-item:hover {\n        background-color: grey;\n    }\n\n.listbox-item-selected {\n    background-color: var(--primary-color);\n}\n\n    .listbox-item-selected:hover {\n        background-color: var(--primary-color);\n    }\n\n.online_indicator {\n    margin-left: 20px;\n    width: 20px;\n    height: 20px;\n    border: 1px solid transparent;\n    border-radius: 10px;\n    background-color: green;\n\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);\n    transform: scale(1);\n    animation: pulse 2s infinite;\n}\n.online {\n    background-color: green;\n}\n.offline {\n    background-color: red;\n}\n@keyframes pulse {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n    }\n\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n    }\n}\n\n.messageGrid {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    grid-template-rows: auto 1fr;\n}\n\n.messageGrid > * {\n    margin-top: 5px;\n    align-self: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
